import React, { useState, useContext, useEffect } from "react";
import Input from "../../modals/parts/Input";
import Select from "../../components/Select";
import List from "../../modals/parts/List";
import classNames from "classnames";
import { liquidityList } from "../../placeholder";
import useDropdown from "../../components/hooks/useDropdown";
import Wrapper from "../../components/Wrapper";
import { useDispatch } from "react-redux";
import { removeLiquidity, swapSupply } from "../../redux/actions/modal";
import SwapSettings from "../../modals/SwapSettings";
import { swapSettingsData } from "../../placeholder";
import {
  addLiquidity,
  getERC20BalanceByAddress,
  getERC20Contract,
  isErc20Approved,
  approveErc20,
  calcTokenDesired,
} from "../../apis/blockchain";
import { Web3Context } from "../../contexts/Web3Context";
import { currencies, sf, pools } from "./currencies";
import { ethers } from "ethers";

const Item = ({ id, style, item, web3Context, deadline, slippage }) => {
  const [ref, styles, open, setOpen] = useDropdown({ speed: 100 });
  const dispatch = useDispatch();
  const [balanceFirst, setBalanceFirst] = useState("");
  const [balanceSecond, setBalanceSecond] = useState("");
  const [percent, setPercent] = useState("");
  const [lpBalance, setLpBalance] = useState({});

  const [isApproved, setIsApproved] = useState(false);

  const findBalances = async () => {
    let lpContract = await getERC20Contract(
      web3Context.web3.web3Provider,
      item.lpAddress
    );

    let [totalSupply, _balanceFirst, _balanceSecond, _lpBalance] =
      await Promise.all([
        lpContract.totalSupply(),
        getERC20BalanceByAddress(
          web3Context.web3.web3Provider,
          item.first.address,
          item.lpAddress
        ),
        getERC20BalanceByAddress(
          web3Context.web3.web3Provider,
          item.second.address,
          item.lpAddress
        ),
        getERC20BalanceByAddress(
          web3Context.web3.web3Provider,
          item.lpAddress,
          web3Context.currentAccountAddress
        ),
      ]);

    let percentPool =
      parseInt(_lpBalance.toString()) / parseInt(totalSupply.toString());

    if (
      item.first.address == "0xaa50040d1b969086883a79b324b9cd4565642d99" ||
      item.first.address == "0x31bb1f238105ae81ab63208849596cf49eb54b95"
    ) {
      _balanceFirst = ethers.utils.formatUnits(_balanceFirst, 6) * percentPool;
    } else {
      _balanceFirst = ethers.utils.formatEther(_balanceFirst) * percentPool;
    }

    if (
      item.second.address == "0xaa50040d1b969086883a79b324b9cd4565642d99" ||
      item.second.address == "0x31bb1f238105ae81ab63208849596cf49eb54b95"
    ) {
      _balanceSecond =
        ethers.utils.formatUnits(_balanceSecond, 6) * percentPool;
    } else {
      _balanceSecond = ethers.utils.formatEther(_balanceSecond) * percentPool;
    }

    _balanceFirst = parseInt(_balanceFirst * 1000000) / 1000000;
    _balanceSecond = parseInt(_balanceSecond * 1000000) / 1000000;

    setBalanceFirst(_balanceFirst.toString());
    setBalanceSecond(_balanceSecond.toString());
    setPercent(parseInt(percentPool * 10000) / 100);
    setLpBalance(_lpBalance.toString());
  };

  const checkApproved = async () => {
    if (web3Context.currentAccountAddress) {
      const tokenAddress = item.lpAddress;
      const approved = await isErc20Approved(
        web3Context.web3.web3Provider,
        tokenAddress,
        web3Context.currentAccountAddress,
        web3Context.web3.rAskoSwapRouterContract.address
      );
      setIsApproved(approved);
    }
  };

  const approve = async () => {
    const tokenAddress = item.lpAddress;

    await approveErc20(
      web3Context.web3.web3Provider,
      tokenAddress,
      web3Context.web3.rAskoSwapRouterContract.address
    );
    setIsApproved(true);
  };

  useEffect(() => {
    findBalances();
    checkApproved();
  }, []);

  return (
    <div
      className={classNames("liquidity-item", { opened: open })}
      style={style}
    >
      <button
        onClick={() => setOpen(!open)}
        className="liquidity-item__title-button"
      >
        Pool {id}
      </button>
      <div ref={ref} style={styles} className="liquidity-item__dropdown">
        <ul className="lq-dropdown__list">
          <li className="lq-dropdown__item">
            Pair: {item.first.name}/{item.second.name}
          </li>
          <li className="lq-dropdown__item">
            Pooled Amount {item.first.name}: {balanceFirst}
          </li>
          <li className="lq-dropdown__item">
            Pooled Amount {item.second.name}: {balanceSecond}
          </li>
          <li className="lq-dropdown__item">Share of Pool: {percent}%</li>
        </ul>

        <div className="lq-dropdown__btns">
          {isApproved ? (
            <button
              className="button-b"
              onClick={() =>
                dispatch(
                  removeLiquidity({
                    balanceFirst: balanceFirst,
                    balanceSecond: balanceSecond,
                    web3Context: web3Context,
                    poolData: item,
                    lpBalance: lpBalance,
                    deadline: deadline,
                    slippage: slippage,
                  })
                )
              }
            >
              Remove Liquidity
            </button>
          ) : (
            <button className="button-b" onClick={approve}>
              Approve LP
            </button>
          )}

          {/* <button className="button-b">Add Liquidity</button> */}
        </div>
      </div>
    </div>
  );
};

export default function () {
  const [is1Approved, setIs1Approved] = useState(false);
  const [is2Approved, setIs2Approved] = useState(false);
  const [max1, setMax1] = useState(0);
  const [max2, setMax2] = useState(0);
  const [balance1, setBalance1] = useState(0);
  const [balance2, setBalance2] = useState(0);
  const [liquidity, setLiquidity] = useState("ADD");
  const [tokenBDesired, setTokenBDesired] = useState("");
  const [settings, setSettings] = useState(false);
  const [formData, setFormData] = useState({
    from: "",
    to: "",
    selectfrom: sf[0],
    selectto: sf[1],
  });
  const changeHandler = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const dispatch = useDispatch();

  const web3Context = useContext(Web3Context);

  const approve1 = async () => {
    const token = currencies[formData.selectfrom.value];

    await approveErc20(
      web3Context.web3.web3Provider,
      token.address,
      web3Context.web3.rAskoSwapRouterContract.address
    );
    setIs1Approved(true);
  };
  const approve2 = async () => {
    const token = currencies[formData.selectto.value];

    await approveErc20(
      web3Context.web3.web3Provider,
      token.address,
      web3Context.web3.rAskoSwapRouterContract.address
    );
    setIs2Approved(true);
  };

  useEffect(() => {
    setIs1Approved(false);
    checkApproved1();
  }, [web3Context, formData.selectfrom]);

  useEffect(() => {
    setIs2Approved(false);
    checkApproved2();
  }, [web3Context, formData.selectto]);

  const checkApproved1 = async () => {
    if (web3Context.currentAccountAddress) {
      const tokenAddress = currencies[formData.selectfrom.value].address;
      const approved = await isErc20Approved(
        web3Context.web3.web3Provider,
        tokenAddress,
        web3Context.currentAccountAddress,
        web3Context.web3.rAskoSwapRouterContract.address
      );
      setIs1Approved(approved);
    }
  };

  const checkApproved2 = async () => {
    if (web3Context.currentAccountAddress) {
      const tokenAddress = currencies[formData.selectto.value].address;
      const approved = await isErc20Approved(
        web3Context.web3.web3Provider,
        tokenAddress,
        web3Context.currentAccountAddress,
        web3Context.web3.rAskoSwapRouterContract.address
      );
      setIs2Approved(approved);
    }
  };

  const [settingsData, setSettingsData] = useState({
    slippage: 0.1,
    slippageInput: "",
    deadline: "20",
  });

  useEffect(() => {
    findBalance1();
    findBalance2();
    findTokenBDesired();
  }, [formData, web3Context]);

  const findBalance1 = async () => {
    if (web3Context.currentAccountAddress) {
      const tokenAddress = currencies[formData.selectfrom.value].address;
      let balanceNew = await getERC20BalanceByAddress(
        web3Context.web3.web3Provider,
        tokenAddress,
        web3Context.currentAccountAddress
      );

      if (
        tokenAddress == "0xaa50040d1b969086883a79b324b9cd4565642d99" ||
        tokenAddress == "0x31bb1f238105ae81ab63208849596cf49eb54b95"
      ) {
        balanceNew = ethers.utils.formatUnits(balanceNew, 6);
      } else {
        balanceNew = ethers.utils.formatEther(balanceNew);
      }

      balanceNew = parseInt(balanceNew * 1000000) / 1000000;

      setBalance1(balanceNew);
      setMax1(balanceNew);
    }
  };

  const findBalance2 = async () => {
    if (web3Context.currentAccountAddress) {
      const tokenAddress = currencies[formData.selectto.value].address;
      let balanceNew = await getERC20BalanceByAddress(
        web3Context.web3.web3Provider,
        tokenAddress,
        web3Context.currentAccountAddress
      );

      if (
        tokenAddress == "0xaa50040d1b969086883a79b324b9cd4565642d99" ||
        tokenAddress == "0x31bb1f238105ae81ab63208849596cf49eb54b95"
      ) {
        balanceNew = ethers.utils.formatUnits(balanceNew, 6);
      } else {
        balanceNew = ethers.utils.formatEther(balanceNew);
      }

      balanceNew = parseInt(balanceNew * 1000000) / 1000000;

      setBalance2(balanceNew);
      setMax2(balanceNew);
    }
  };

  const findTokenBDesired = async () => {
    if (web3Context.currentAccountAddress) {
      const tokenAddressA = currencies[formData.selectfrom.value].address;
      const tokenAddressB = currencies[formData.selectto.value].address;

      let amount1;
      if (
        tokenAddressA == "0xaa50040d1b969086883a79b324b9cd4565642d99" ||
        tokenAddressA == "0x31bb1f238105ae81ab63208849596cf49eb54b95"
      ) {
        amount1 = ethers.utils.parseUnits(formData.from.toString(), 6);
      } else {
        amount1 = ethers.utils.parseEther(formData.from.toString());
      }

      let tokenBDesired = await calcTokenDesired(
        web3Context.web3.rAskoSwapRouterContract,
        amount1,
        tokenAddressA,
        tokenAddressB,
        web3Context.web3.rAskoSwapLibraryContract
      );

      if (
        tokenAddressB == "0xaa50040d1b969086883a79b324b9cd4565642d99" ||
        tokenAddressB == "0x31bb1f238105ae81ab63208849596cf49eb54b95"
      ) {
        tokenBDesired = ethers.utils.formatUnits(tokenBDesired, 6);
      } else {
        tokenBDesired = ethers.utils.formatEther(tokenBDesired);
      }

      tokenBDesired = parseInt(tokenBDesired * 1000000) / 1000000;

      setTokenBDesired(tokenBDesired);
    }
  };

  const submit = (e) => {
    e.preventDefault();

    const fromToken = currencies[formData.selectfrom.value];
    const toToken = currencies[formData.selectto.value];

    let amount1, amount2;

    if (
      fromToken.address == "0xaa50040d1b969086883a79b324b9cd4565642d99" ||
      fromToken.address == "0x31bb1f238105ae81ab63208849596cf49eb54b95"
    ) {
      amount1 = ethers.utils.parseUnits(formData.from.toString(), 6);
    } else {
      amount1 = ethers.utils.parseEther(formData.from.toString());
    }

    if (
      toToken.address == "0xaa50040d1b969086883a79b324b9cd4565642d99" ||
      toToken.address == "0x31bb1f238105ae81ab63208849596cf49eb54b95"
    ) {
      amount2 = ethers.utils.parseUnits(tokenBDesired.toString(), 6);
    } else {
      amount2 = ethers.utils.parseEther(tokenBDesired.toString());
    }

    let slippage;

    if (settingsData.slippageInput) {
      slippage = parseFloat(settingsData.slippageInput);
    } else {
      slippage = settingsData.slippage;
    }

    const min1 = parseInt(amount1 * (1 - slippage / 100));
    const min2 = parseInt(amount2 * (1 - slippage / 100));

    console.log(Date.now() / 10000 + settingsData.deadline * 60 + "");

    addLiquidity(
      web3Context.web3.rAskoSwapRouterContract,
      fromToken.address,
      toToken.address,
      amount1,
      amount2,
      min1 + "",
      min2 + "",
      web3Context.currentAccountAddress,
      parseInt(Date.now() / 1000) + settingsData.deadline * 60 + ""
    );
  };

  return (
    <form
      className={classNames("swap-form", {
        "swap-form_pd": liquidity === "ALL",
      })}
      onSubmit={(e) => e.preventDefault()}
    >
      <div className="swap-form__header">
        <span className="swap-h-hide">&nbsp;</span>
        <div className="swap-form__controls">
          <button
            className={classNames({ active: liquidity === "ADD" })}
            onClick={() => setLiquidity("ADD")}
          >
            Add Liquidity
          </button>
          <button
            className={classNames({ active: liquidity === "ALL" })}
            onClick={() => setLiquidity("ALL")}
          >
            Your Liquidity
          </button>
        </div>
        <button
          className="swap-form__settings"
          onClick={() => setSettings(!settings)}
        ></button>

        {settings === true && (
          <SwapSettings
            onClose={() => setSettings(false)}
            data={swapSettingsData}
            settingsData={settingsData}
            setSettingsData={setSettingsData}
          />
        )}
      </div>

      <div className="swap-form__body">
        {liquidity === "ADD" ? (
          <>
            <div className="swap-form__title">
              <span>Input</span>
              <span>Balance: {balance1}</span>
            </div>

            <div className="swap-form__field">
              <Input
                className="swap-form__input"
                type="text"
                name="from"
                value={formData.from}
                onChange={changeHandler}
                maxEnable={true}
                maxHandler={() => setFormData({ ...formData, from: max1 })}
              />
              <div className="swap-form__select">
                <Select
                  className="sf__select"
                  current={formData.selectfrom.value}
                  setValue={changeHandler}
                  name="selectfrom"
                >
                  {sf.map((item) => (
                    <Select.Item key={item.id} item={item} />
                  ))}
                </Select>
              </div>
            </div>
            <div className="swap-form__img">
              <span className="plus">+</span>
            </div>

            <div className="swap-form__title swap-form__title_mt">
              <span>Input</span>
              <span>Balance: {balance2}</span>
            </div>

            <div className="swap-form__field">
              <Input
                className="swap-form__input"
                type="text"
                name="to"
                value={tokenBDesired}
                onChange={changeHandler}
                maxEnable={true}
                maxHandler={() => setFormData({ ...formData, to: max2 })}
                readonly={true}
              />
              <div className="swap-form__select">
                <Select
                  className="sf__select"
                  current={formData.selectto.value}
                  setValue={changeHandler}
                  name="selectto"
                >
                  {sf.map((item) => (
                    <Select.Item key={item.id} item={item} />
                  ))}
                </Select>
              </div>
            </div>

            {/*
            <div className="swap-form__subtitle">
              <span className="sf-blue">Price</span>
              <span className="sf-bprice">.01 LR WBNB for 1 LR YEET</span>
            </div>
            */}

            {/* <List className="swap-form__sublist">
              <List.Item title="Share of Pool: 0.03%" />
            </List> */}

            {is1Approved && is2Approved ? (
              <button
                type="submit"
                className="custom-button swap-form__submit"
                //onClick={() => dispatch(swapSupply())}
                onClick={submit}
              >
                <span>Supply</span>
              </button>
            ) : is1Approved ? (
              <button
                type="submit"
                className="custom-button swap-form__submit"
                //onClick={() => dispatch(swapSupply())}
                onClick={approve1}
              >
                <span>Approve {formData.selectfrom.value}</span>
              </button>
            ) : (
              <button
                type="submit"
                className="custom-button swap-form__submit"
                //onClick={() => dispatch(swapSupply())}
                onClick={approve2}
              >
                <span>Approve {formData.selectfrom.value}</span>
              </button>
            )}
          </>
        ) : (
          <>
            <div className="liquidity">
              <div className="liquidity__list">
                <Wrapper
                  showItems={5}
                  marginTop={27}
                  className="liquidity__list-items custom-scrollbar"
                >
                  {pools.map((item) => (
                    <Item
                      key={item.id}
                      item={item}
                      web3Context={web3Context}
                      deadline={settingsData.deadline}
                      slippage={settingsData.slippage}
                    />
                  ))}
                </Wrapper>
              </div>
            </div>

            {/* <button
              type="submit"
              className="custom-button swap-form__submit liquidity__submit"
            >
              <span>Add Liquidity</span>
            </button> */}
          </>
        )}
      </div>
    </form>
  );
}
